export default "__VITE_ASSET__uobgIbAX__"